import { render } from "./TableSkeleton.vue?vue&type=template&id=f268e252&scoped=true"
import script from "./TableSkeleton.vue?vue&type=script&lang=js"
export * from "./TableSkeleton.vue?vue&type=script&lang=js"

import "./TableSkeleton.vue?vue&type=style&index=0&id=f268e252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f268e252"]])

export default __exports__